import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import posthog from 'posthog-js'

export default function PostHogPageView() {
  const location = useLocation()

  useEffect(() => {
    if (import.meta.env.VITE_ENVIRONMENT !== 'prod') return
    if (!posthog.__loaded) return

    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: `${location.pathname}${location.search}`,
    })
  }, [location.pathname, location.search])

  return null
}
